import licenseModule from '../../license.module';

export default licenseModule.component('licenseConsoleNewServer', {
    template: require('./licenseConsoleNewServer.component.html'),
    controller: [
        '$cookies',
        '$scope',
        '$window',
        'cookieConstants',
        'LicenseManagementService',
        licenseConsoleNewServerComponent
    ],
    bindToController: true
});

function licenseConsoleNewServerComponent(
    $cookies,
    $scope,
    $window,
    cookieConstants,
    LicenseManagementService
) {
    var vm = this;
    vm.showLoading = true;
    vm.getDisabled = true;

    $window.addEventListener('message', receiveMessage);

    // A function to process messages received by the window.
    function receiveMessage(e) {
        // Update the div element to display the message.
        if (
            e.data != null &&
            e.data !== undefined &&
            e.data.serverProfile !== undefined &&
            e.data.serverProfile != ''
        ) {
            vm.license.server.name = e.data.name;
            vm.license.server.payload = e.data.serverProfile;
            vm.showLoading = false;
            $scope.$apply();
        }
    }

    vm.$onInit = function() {
        vm.currentPage = 0;
        vm.navs = ['detail'];

        LicenseManagementService.getAppspaceIDSummary().then(function(data) {
            vm.summary = data;

            // Subscription
            if (vm.summary.subscription.premiumUserId.total > 0) {
                vm.summaryDeviceIdTotal =
                    vm.summary.subscription.deviceId.total;
                vm.summaryPremiumUserIdTotal =
                    vm.summary.subscription.premiumUserId.total;

                vm.summaryDeviceIdUsage =
                    vm.summary.subscription.deviceId.usage;
                vm.summaryPremiumUserIdUsage =
                    vm.summary.subscription.premiumUserId.usage;
            }
            // Perpetual
            if (
                vm.summary.perpetual.premiumUserId.total -
                    vm.summary.perpetual.premiumUserId.usage >
                    0 ||
                (vm.summary.subscription.premiumUserId.total == 0 &&
                    vm.summary.perpetual.premiumUserId.total > 0) ||
                (vm.summary.type == 'legacy' ||
                    vm.summary.subscription.premiumUserId.total == 0)
            ) {
                vm.summaryPerpetualDeviceIdTotal =
                    vm.summary.perpetual.deviceId.total;
                vm.summaryPerpetualPremiumUserIdTotal =
                    vm.summary.perpetual.premiumUserId.total;

                vm.summaryPerpetualDeviceIdUsage =
                    vm.summary.perpetual.deviceId.usage;
                vm.summaryPerpetualPremiumUserIdUsage =
                    vm.summary.perpetual.premiumUserId.usage;
            }

            // Perpetual Only
            if (
                vm.summary.type == 'legacy' ||
                vm.summary.subscription.premiumUserId.total == 0
            ) {
                vm.onlyPerpetual = true;
                vm.summaryPerpetualDeviceIdTotal =
                    vm.summary.perpetual.deviceId.total;
                vm.summaryPerpetualPremiumUserIdTotal =
                    vm.summary.perpetual.premiumUserId.total;

                vm.summaryPerpetualDeviceIdUsage =
                    vm.summary.perpetual.deviceId.usage;
                vm.summaryPerpetualPremiumUserIdUsage =
                    vm.summary.perpetual.premiumUserId.usage;
            }

            if (vm.onlyPerpetual) {
                vm.navs.push('perpetual');
            } else if (
                vm.summary.subscription.premiumUserId.total > 0 &&
                vm.summary.perpetual.premiumUserId.total == 0 &&
                vm.summary.perpetual.deviceId.total == 0
            ) {
                vm.navs.push('subscription');
            } else {
                vm.navs.push('subscription', 'perpetual');
            }
        });

        vm.license = {
            server: {
                payload: '',
                name: '',
                description: '',
                countryCode: '',
                profiles: []
            },
            subscription: {
                maxUsers: 0,
                maxDevices: 0
            },
            perpetual: {
                maxUsers: 0,
                maxDevices: 0
            },
            eula: false,
            payload: '',
            serverProfileError: false,
            hideButton: false
        };

        // Post callback message to on-premise to inform that the initialization of UI has completed.
        $window.parent.postMessage(
            {
                action: 'startStaticOnline'
            },
            '*'
        );
    };

    vm.next = function() {
        vm.getDisabled = true;

        if (vm.currentPage !== vm.navs.length - 1) {
            vm.currentPage++;

            if (vm.navs[vm.currentPage] == 'detail') {
                vm.getDisabled =
                    vm.license.server.name === undefined ||
                    vm.license.name == '' ||
                    vm.license.server.countryCode === undefined ||
                    vm.license.server.countryCode == '' ||
                    !vm.license.eula;
            } else if (vm.navs[vm.currentPage] == 'subscription') {
                vm.getDisabled =
                    vm.license.subscription.maxUsers === undefined ||
                    vm.license.subscription.maxUsers == 0;
            } else {
                if (vm.onlyPerpetual) {
                    vm.getDisabled =
                        vm.license.perpetual.maxUsers === undefined ||
                        vm.license.perpetual.maxUsers == 0;
                } else {
                    vm.getDisabled = false;
                }
            }
        } else {
            $window.parent.postMessage(
                {
                    action: 'createInstance'
                },
                '*'
            );

            LicenseManagementService.createInstance(vm.license).then(
                function(data) {
                    $window.parent.postMessage(
                        {
                            action: 'instanceGuid',
                            params: data
                        },
                        '*'
                    );
                },
                function(data) {
                    $window.parent.postMessage(
                        {
                            action: 'error',
                            params: data
                        },
                        '*'
                    );
                }
            );
        }
    };

    vm.back = function() {
        vm.currentPage--;
        if (vm.navs[vm.currentPage] == 'detail' && vm.license.eula === true) {
            vm.getDisabled = false;
        }
    };

    vm.callbackServerDetails = function(data) {
        if (
            data.name !== undefined &&
            data.name != '' &&
            data.name.length <= 100 &&
            (data.countryCode !== undefined && data.countryCode != '') &&
            (data.description !== undefined &&
                data.description.length <= 100) &&
            data.eula == true
        ) {
            vm.license.server.name = data.name;
            vm.license.server.countryCode = data.countryCode;
            vm.license.server.description = data.description;
            vm.license.eula = data.eula;
            vm.getDisabled = false;
        } else {
            vm.getDisabled = true;
        }
    };

    vm.callbackSubscription = function(data) {
        vm.balancePremiumUserId =
            vm.summary.subscription.premiumUserId.total -
            vm.summary.subscription.premiumUserId.usage;

        vm.balanceDeviceId =
            vm.summary.subscription.deviceId.total -
            vm.summary.subscription.deviceId.usage;

        if (
            data.license.maxUsers > vm.balancePremiumUserId ||
            data.license.maxDevices > vm.balanceDeviceId ||
            data.license.maxUsers == 0 ||
            data.license.maxUsers == undefined ||
            data.license.maxDevices == undefined
        ) {
            vm.getDisabled = true;
        } else {
            vm.license.subscription.maxDevices = data.license.maxDevices;
            vm.license.subscription.maxUsers = data.license.maxUsers;

            vm.getDisabled = false;
        }
    };

    vm.callbackPerpetual = function(data) {
        vm.balancePerpetualPremiumUserId =
            vm.summary.perpetual.premiumUserId.total -
            vm.summary.perpetual.premiumUserId.usage;

        vm.balancePerpetualDeviceId =
            vm.summary.perpetual.deviceId.total -
            vm.summary.perpetual.deviceId.usage;
        // Perpetual Only
        if (
            vm.onlyPerpetual == true ||
            vm.summary.subscription.premiumUserId.total == 0
        ) {
            if (
                data.license.maxUsers > vm.balancePerpetualPremiumUserId ||
                data.license.maxDevices > vm.balancePerpetualDeviceId ||
                data.license.maxUsers == 0 ||
                data.license.maxUsers == undefined ||
                data.license.maxDevices == undefined
            ) {
                vm.getDisabled = true;
            } else {
                vm.license.perpetual.maxDevices = data.license.maxDevices;
                vm.license.perpetual.maxUsers = data.license.maxUsers;
                vm.getDisabled = false;
            }
        } else if (
            vm.onlyPerpetual == false ||
            vm.summary.subscription.premiumUserId.total > 0
        ) {
            // Subscription with Perpetual
            if (
                data.license.maxUsers === undefined ||
                data.license.maxUsers == null ||
                data.license.maxUsers > vm.balancePerpetualPremiumUserId ||
                (data.license.maxDevices === undefined ||
                    data.license.maxDevices == null ||
                    data.license.maxDevices > vm.balancePerpetualDeviceId)
            ) {
                vm.getDisabled = true;
            } else {
                vm.license.perpetual.maxDevices = data.license.maxDevices;
                vm.license.perpetual.maxUsers = data.license.maxUsers;
                vm.getDisabled = false;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-console-new-server/licenseConsoleNewServer.component.js